import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Image = styled.img`
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(8)};
`;

export const Badge = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  align-self: center;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};
  border-radius: ${({ theme }) => theme.spacing(8)};
  background: ${({ theme }) => theme.palette.info.light};
  color: ${({ theme }) => theme.palette.info.dark};
  margin-left: ${({ theme }) => theme.spacing(1)};
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const Bullets = styled.ul`
  padding-left: ${({ theme }) => theme.spacing(3.75)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: 0;
`;

export const Bullet = styled.li`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const BulletLabel = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

// -2.5 cancels the Medium Text button's padding + border so the link label left-aligns
export const LinkContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-left: ${({ theme }) => theme.spacing(-2.5)};
`;
